import items from "./items.json"
export interface Iitems {
    name: string
    type: string
    imageSrc: string
    loyaltyprice?: number
    ItemId: string
    selected: boolean
    success: boolean
    category: string
}

export const ITEMS = (): Iitems[] => {
  return items
}